import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('BuyKeysModal').create(({ theme }) => ({
  root: {
    position: 'absolute',
    zIndex: 999,
    left: '0%',
    width: '100vw',
    height: '100%',
    transform: 'translateY(-210%)',
    transition: 'transform 0.3s ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  modalRoot: {
    backgroundColor: 'rgba(29, 30, 34, 1)',
  },

  modalTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
  },

  backdrop: {
    height: '100vh',
    width: '100vw',
    position: 'fixed',
    top: '0',
    left: '0',
    gap: '12px',
    zIndex: '995',
    backgroundColor: 'transparent',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    flexDirection: 'column',

    '&[data-open="false"]': {
      display: 'none',
    },
  },

  isShowing: {
    transform: 'translateY(0%)',
  },

  keyList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '12px',
    overflow: 'auto',
    color: theme.colors.text.primary,
  },

  keyListHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: '#757778',
    padding: '12px 0px',
    textTransform: 'uppercase',
  },

  keyListItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: '12px',
    color: theme.colors.text.primary,
    padding: '12px 0px',
  },
  keyListItemContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '6px',
    color: theme.colors.text.primary,
  },

  textAndArrowWrapper: {
    display: 'flex',
    gap: '8px',
  },

  stars: {
    color: theme.colors.text.secondary,
  },
}))
